import * as actionTypes from './actionTypes'

export function initializeSubHrdValues(payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_SUBHRD,
    payload
  }
}

export function updateActorFeild(actor, field, payload) {
  return {
    type: actionTypes.UPDATE_ACTOR_FIELD,
    payload,
    field,
    actor
  }
}


export function updateField(field, payload) {
  return {
    type: actionTypes.UPDATE_FIELD,
    payload,
    field
  }
}

export function saveSubHrdField(field, payload, formType) {
  return {
    type: actionTypes.SAVE_SUBHRD_FIELD,
    payload,
    field,
    formType,
  }
}

export function updateContainerNumber(containerid, containerNum) {
  return {
    type: actionTypes.UPDATE_CONTAINER_NUMBER_FIELD,
    containerid,
    containerNum
  }
}

export function saveContainerNumber(containerid, containerNum) {
  return {
    type: actionTypes.SAVE_CONTAINER_NUMBER_FIELD,
    "containerid": containerid,
    "containerNum": containerNum
  }
}

export function addNewContainerItem(){
  return {
    type: actionTypes.ADD_NEW_CONTAINER
  }
}

export function removeContainerItem(containerid){
  return {
    type: actionTypes.REMOVE_CONTAINER,
    containerid
  }
}
export function updateContainerOnResponse(containers){
  return {
    type: actionTypes.UPDATE_CONTAINER_ON_RESPONSE,
    containers
  }
}
